/**
 * Formátovací helpery fronty odkupů. Peníze, čas a cenu jednotky přebírá z fáze
 * přidělení jednotek — nezdvojujeme je (jeden zdroj pravdy pro CZK/čas/cenu).
 * Navíc jen dvě věci, které odkup potřebuje jinak: jednotky na 4 desetinná místa
 * (fronta se čte, ne audituje) a sazba v procentech.
 */

import { formatCzk, formatDate, formatDateTime, formatUnits } from '../jednotky/format'

// Fronta odkupů zobrazuje jednotky na 4 des. místa; plnou přesnost (8 des.) drží
// cena jednotky a detail odkupu, kde se čísla ověřují proti výpisu.
const units4 = new Intl.NumberFormat('cs-CZ', {
  minimumFractionDigits: 4,
  maximumFractionDigits: 4,
})

/** Počet jednotek na 4 desetinná místa, seskupený — např. „1 234,5678". */
export function formatUnits4(units: number): string {
  return units4.format(units)
}

const ratePercent = new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 2 })

/** Sazba jako poměr → procenta, např. 0,15 → „15 %"; 0,0147 → „1,47 %". */
export function formatRate(rate: number): string {
  return `${ratePercent.format(rate * 100)} %`
}

export { formatCzk, formatDate, formatDateTime, formatUnits }
